import { RoleService } from './../shared/role.service';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { ModulosListComponent } from './modulos-list.component';
// import { IRol } from '../roles/rol';
// import { RolesService } from '../roles/roles.service';
import * as myGlobals from './../global';
import { Role } from '../shared/role.model';

@Component({
  selector: 'pm-add-modulo',
  templateUrl: './add-modulo.component.html',
  styleUrls: ['./add-modulo.component.sass']
})
export class AddModuloComponent implements OnInit, AfterViewInit, OnDestroy {
  private _rolesService;
  roles: Role[] = [];
  errorMessage = '';

  constructor(private rolesService: RoleService, private parent: ModulosListComponent) {
    this._rolesService = rolesService;
  }

  ngAfterViewInit() {
    $('a[rel=modulos]').addClass('selected');
  }

  ngOnInit() {
    console.log(this.parent.editnumber);
    this.getActiveRoles();
  }

  cancelModulo(): void {
    this.parent.showModulos = true;
    this.parent.showAddModulo = false;
  }

  addModulo(): void {
    console.log('Guardar Modulo');
    let formData = {
      nombre: $('input[name=nombre]').val(),
      id_pantalla: $('input[name=id_pantalla]').val(),
      rol_id: $('#myselect option:selected').val()
    };

    this.parent.showModulos = true;
    this.parent.showAddModulo = false;
  }
  getActiveRoles() {
    this._rolesService
      .getActiveRoles()
      .subscribe(roles => (this.roles = roles), error => (this.errorMessage = error as any));
  }

  ngOnDestroy() {
    $('a[rel=modulos]').removeClass('selected');
  }
}
